import { SCROLL_LOCK } from "Helper/cssClasses";

const htmlElement = document.documentElement;
const bodyElement = document.body;

// scroll top position before the scroll was locked (overflow:hidden)
let scrollTop = 0;

let scrollPositionChangedAfterLock = false;

// prevents user from scrolling the page. usefull for example when an overlay is open
export const scrollLock = {
  lock() {
    scrollTop = htmlElement.scrollTop;
    htmlElement.classList.add(SCROLL_LOCK);
    // scroll back to the original position after it jumps back to top because of the overflow:hidden
    htmlElement.scrollTop = scrollTop;
    // on iOS the scroll top jumps shorty after being set to a value, back to zero when html->overflow:hidden
    setTimeout(() => {
      scrollPositionChangedAfterLock = htmlElement.scrollTop !== scrollTop;
    }, 100);
  },
  unLock() {
    htmlElement.classList.remove(SCROLL_LOCK);
    // iOS needs this
    if (scrollPositionChangedAfterLock) htmlElement.scrollTop = scrollTop;
  },
  pageBodyLock() {
    scrollTop = bodyElement.scrollTop;
    bodyElement.classList.add(SCROLL_LOCK);

    // scroll back to the original position after it jumps back to top because of the overflow:hidden
    bodyElement.scrollTop = scrollTop;

    // on iOS the scroll top jumps shorty after being set to a value, back to zero when html->overflow:hidden
    setTimeout(() => {
      scrollPositionChangedAfterLock = bodyElement.scrollTop !== scrollTop;
    }, 100);
  },
  pageBodyUnlock() {
    bodyElement.classList.remove(SCROLL_LOCK);
    // iOS needs this
    if (scrollPositionChangedAfterLock) bodyElement.scrollTop = scrollTop;
  },
};
